<template>
    <div
        v-if="useChannel"
        :class="showTalkList? 'is-extend': ''"
        class="md talk-box"
    >
        <div class="heading">
            <div class="caption">
                <div class="image"
                    :style="'background-image: url('+ $talkTool.getAvatar(useChannel) +')'"
                ></div>
                <div class="name">
                    <div class="box">{{ useChannel.name }}</div>
                </div>
            </div>
            <ul class="func">
                <li class="minisize"><a @click="talkMiniSize(useChannel)"></a></li>
                <li class="remove"><a @click="talkInterfaceClose(useChannel)"></a></li>
            </ul>
        </div>
        <div class="content">
            <div
                class="panel"
                v-if="stickerPanel"
                @click="closePanel"
            >
                <ul class="sticker">
                    <li v-for="item in stickerList" :key="item.filename">
                        <a 
                            :style="'background-image: url('+ $siteConfig.talkDomainUrl +'/sticker/'+ item.filename +')'"
                            @click.stop="sendSticker(item)"    
                        ></a>
                    </li>
                </ul>
                <ul class="func">
                    <li class="remove"><a @click.stop="closePanel"></a></li>
                </ul>
            </div>
            <div
                class="box"
                ref="content"
            >
                <ul class="talk">
                    <li
                        v-for="talk in talkList"
                        :key="talk.sn"
                        :class="[talk.self === true? 'is-self': '', talk.self === false? 'is-other': '', talk.self === null? 'is-system': '']"
                    >
                        <div
                            v-if="talk.type === 'date'"
                            class="date-content"
                        >{{ talk.content }}</div>
                        <div
                            v-else
                            class="figure-content"
                        >
                            <div class="user-image">
                                <div
                                    class="image"
                                    :style="'background-image: url('+ $talkTool.getAvatar(talk) +')'"
                                ></div>
                            </div>
                            <div class="message-content">
                                <div class="user-name">{{ talk.name }}</div>
                                <div class="text-content">
                                    <div
                                        v-if="talk.type === 'talk'"
                                        class="text"
                                        v-html="talk.content"
                                    ></div>
                                    <div
                                        v-else-if="talk.type === 'url'"
                                        class="text"
                                    >
                                        <a
                                            class="url is-link"
                                            :href="talk.url"
                                            target="_blank"
                                        >{{ talk.content }}</a>
                                    </div>
                                    <div
                                        class="text"
                                        v-else-if="talk.type === 'file'"
                                    >
                                        <a
                                            class="url is-file"
                                            @click="getFile(talk.sn)"
                                        >{{ talk.content }}</a>
                                    </div>
                                    <div
                                        v-else-if="talk.type === 'sticker'"
                                        class="image is-sticker"
                                        :style="'background-image: url('+ getSticker(talk.sn) +')'"
                                    ></div>
                                    <div
                                        v-else-if="talk.type === 'image'"
                                        class="image is-pic"
                                        @click="getImageFile(talk.sn)"
                                        :style="'background-image: url('+ thumbnail[talk.sn] +')'"
                                    >
                                        <cpLabel
                                            themes="expert"
                                            icon="download"
                                            :text="$t('site.func.download')"
                                            @click.native.stop="downloadImage(talk.sn)"
                                        ></cpLabel>
                                    </div>
                                    <div
                                        v-else-if="talk.type === 'product'"
                                        class="product"
                                    >
                                        <router-link
                                            class="div"
                                            :to="talk.content.url"
                                        >
                                            <div
                                                class="image"
                                                :style="'background-image: url('+ talk.content.imageurl +')'"
                                            ></div>
                                            <div class="p">
                                                <div class="caption">{{ talk.content.product_s }}</div>
                                                <div class="price">{{ talk.content.showPrice }}</div>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div
                                        v-else
                                        class="text"
                                    >[{{ $t('talk.alert.unsupported') }}]</div>
                                    <div class="label">
                                        <div class="label">
                                            <div class="time">{{ talk.timeLabel }}</div>
                                            <div v-if="talk.self" class="read">
                                                <span
                                                    v-if="talk.read"
                                                    v-html="$t('talk.label.read') + (useChannel.isGroup? + talk.read: '')"
                                                ></span>
                                                <span v-else>{{ $t('talk.label.unread') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="footer">
            <div class="talk-input">
                <!-- <pre
                    class="box"
                    contenteditable="true"
                    data-placeholder="Aa"
                    ref="input"
                    @keydown.enter="sendByEnter"
                ></pre> -->
                <textarea
                    class="box"
                    placeholder="Shift / Ctrl + Enter 送出"
                    ref="input"
                    @input="changeInputHeight"
                    @keydown.enter="sendByEnter"
                ></textarea>
            </div>
            <ul class="func">
                <li class="file"><a @click="sendFiles"></a></li>
                <!-- <li class="image"><a @click="sendImages"></a></li> -->
                <li class="sticker" :class="[stickerPanel? 'is-active': '']"><a @click="toggleStickerPanel"></a></li>
                <li class="send"><a @click="sendByBtn"></a></li>
            </ul>
        </div>
    </div>
</template>

<script>
    import cpLabel from '@/components/cpLabel'

    import { mapState, mapGetters, mapMutations } from 'vuex'

    export default {
        components: {
            cpLabel,
        },
        data: function(){
            let $location = window.location,
                _origin = $location.origin,
                _pathname = $location.pathname,
                _url = _origin + _pathname +'#';

            return {
                id: 'talk-window',
                scrollPrev: 0,
                show: false,
                thumbnail: {},
                localUrl: _url,
                stickerPanel: false,
                talkList: [],
            }
        },
        computed: {
            ...mapState([
                'talk',
                'showTalkList',
                'talkMessage',
                'talkViewTime',
                'productList',
                'stickerList',
            ]),
            ...mapGetters([
                'useChannel',
            ]),
            aid: function(){
                return this.talk.aid;
            },
        },
        watch: {
            'talk.scroll': {
                handler: function(){

                    this.$nextTick(() => {
                        this.scroll(this.talk.scroll);
                    });
                }
            },
            'talk.cid': {
                handler: function(){
                    this.$nextTick(this.initScroll);
                }
            },
            talkViewTime: {
                handler: function(){
                    this.initTalkList();
                }
            },
            talkMessage: {
                handler: function(){
                    this.initThumbnail();
                    this.initTalkList();
                }
            }
        },
        methods: {
            ...mapMutations([
                'talkSet',
                'talkBubbleShow',
                'talkInterfaceClose',
                'talkSend',
                'talkCommand',
                'pushPopUp',
                'catchError',
            ]),
            initTalkList: function(){
                let $talkMessage = this.talkMessage,
                    _aid = this.aid,
                    $readTimes = this.getReadTimes();

                let _lastDate = '',
                    $result = []

                $talkMessage.forEach(talk => {
                    let $time = this.getTimeObj(talk),
                        _date = $time.month +'/'+ $time.date,
                        _message = talk.message;

                    if( _lastDate !== _date ) {
                        _lastDate = _date;

                        $result.push({
                            sn: _date,
                            type: 'date',
                            content: _date,
                            self: null,
                            read: null,
                            timeLabel: null,
                        });
                    }

                    let _type = 'other',
                        _content = '',
                        _url = '';

                    if( _message.match(/^https?:\/\//) ) {
                        _type = 'url';
                        _content = _message;
                        _url = _message;

                        if( _message.includes(this.localUrl) ) {
                            let _query = _message.replace(this.localUrl, ''),
                                $match = _query.match(/&item=(\d+)$/);

                            if( $match && $match[1] ) {
                                let _product_sn = $match[1],
                                    $product = this.productList.find(product => product.product_sn == _product_sn);

                                if( $product ) {
                                    let _showPrice = this.$okaTool.numberToStringFormat(this.$siteTool.getPrice($product));

                                    if( $product.price ) {
                                        _showPrice = 'NT$ '+ _showPrice;
                                    }

                                    _type = 'product';
                                    _content = {
                                        url: _query,
                                        showPrice: _showPrice,
                                        ...$product,
                                    }
                                }
                            }
                        }
                    }else if( talk.type === 1 ) {
                        _type = 'talk';
                        _content = _message.replaceAll('\n', '<br>');
                    }else if( talk.type === 2 ) {
                        _type = 'image';
                    }if( talk.type === 3 || talk.type === 4 || talk.type === 5 ) { //檔案 mp3 mp4
                        _type = 'file';
                        _content = _message;
                    }else if( talk.type === 6 ) {
                        _type = 'sticker';
                    }else if( talk.type === 21 ) {
                        _type = 'url';
                        _url = talk.extra;
                    }

                    let $read = $readTimes.filter(times => times >= talk.timestamp);

                    $result.push({
                        sn: talk.uuid,
                        avatar: talk.avatar,
                        name: talk.name,
                        type: _type,
                        content: _content,
                        url: _url,
                        self: _aid === talk.aid,
                        read: $read.length,
                        timeLabel: $time.hours +':'+ $time.minutes,
                    });
                });

                this.$set(this, 'talkList', $result);
            },
            getReadTimes: function(){
                let $useChannel = this.useChannel,
                    $result = []

                if( $useChannel ) {
                    let $talkViewTime = this.talkViewTime,
                        _cid = this.talk.cid,
                        $channelViewTime = $talkViewTime[_cid] || {}
                        
                    for(let _key in $channelViewTime) {

                        if( _key != this.aid ) {
                            $result.push($channelViewTime[_key]);
                        }
                    }
                }
                
                return $result;
            },
            changeInputHeight: function() {
                let $textarea = this.$refs.input,
                    _max = 200;

                $textarea.removeAttribute('style');

                if( $textarea.scrollHeight > _max ) {
                    $textarea.style.height = _max +'px';
                    $textarea.style.overflowY = 'scroll';
                }else {
                    $textarea.style.height = ($textarea.scrollHeight) +'px';
                }
            },
            getBlob: function(url, callback){

                this.$http({
                    method: 'get',
                    url: url,
                    headers: {
                        accessToken: this.talk.accessToken,
                    },
                    responseType: 'blob'
                }).then(res => { //弄完所有設定後開始取資料
                    let $file = window.URL.createObjectURL(new Blob([res.data]));

                    callback($file);
                }).catch(error => {
                    console.log(error)
                });
            },
            getTalk: function(uuid) {
                let $talkMessage = this.talkMessage,
                    $talk = $talkMessage.find(talk => talk.uuid === uuid);

                return $talk;
            },
            getSticker: function(uuid){
                let $talk = this.getTalk(uuid);

                return this.$siteConfig.talkDomainUrl +'/upload/sticker/'+ $talk.extra2;
            },
            getFile: function(uuid) {
                let _url = this.$siteConfig.talkDomainUrl,
                    $talk = this.getTalk(uuid);

                _url = _url + '/mediafile/' + $talk.extra + '/' + $talk.extra2;

                this.getBlob(_url, (file) => {
                    this.$siteTool.downloadCore(file, $talk.message);
                });
            },
            getImageFile: function(uuid) {
                let _url = this.$siteConfig.talkDomainUrl,
                    $talk = this.getTalk(uuid);

                _url = _url + '/mediafile/' + $talk.extra + '/' + $talk.extra2;

                this.getBlob(_url, (file) => {

                    this.pushPopUp({
                        type: 'alert',
                        content: {
                            caption: this.$t('talk.image.scorce'),
                            html: '<img src="'+ file +'">',
                            actionName: this.$t('site.func.download'),
                            actionTheme: 'expert',
                            actionIcon: 'download',
                            action: () => {
                                this.downloadImage(uuid);
                            }
                        }
                    })
                });
            },
            downloadImage: function(uuid) {
                let _url = this.$siteConfig.talkDomainUrl,
                    $talk = this.getTalk(uuid);

                _url = _url + '/mediafile/' + $talk.extra + '/' + $talk.extra2;

                this.getBlob(_url, (file) => {
                    let $talkMessage = this.talkMessage,
                        $target = $talkMessage.find(item => item.uuid === uuid),
                        _message = $target.message;

                    this.$siteTool.downloadCore(file, _message);
                });
            },
            getThumbnail: function(talk){
                let _url = this.$siteConfig.talkDomainUrl;

                if( talk.extra2.match(/\.gif$/gi)){
                    _url = _url + '/mediafile/' + talk.extra + '/' + talk.extra2;
                }else {
                    _url = _url + '/upload/thumbnails/' + talk.extra + '/' + talk.extra2.replace(/\.gif$/, '.jpg');
                }

                this.getBlob(_url, (file) => {
                    this.$set(this.thumbnail, talk.uuid, file);
                });
            },
            initThumbnail: function(){
                let $talkMessage = this.talkMessage,
                    $thumbnail = this.thumbnail,
                    $talks = $talkMessage.filter(talk => talk.type === 2 && !$thumbnail[talk.uuid]);
                    
                $talks.forEach(talk => {
                    this.getThumbnail(talk);
                });
            },
            talkMiniSize: function(channel){
                this.talkInterfaceClose();
                this.talkBubbleShow(channel);
            },
            getTimeObj: function(talk){
                let $date = new Date(talk.timestamp),
                    _month = this.$okaTool.doubleCount($date.getMonth() + 1),
                    _date = this.$okaTool.doubleCount($date.getDate()),
                    _hours = this.$okaTool.doubleCount($date.getHours()),
                    _minutes = this.$okaTool.doubleCount($date.getMinutes());

                return {
                    month: _month,
                    date: _date,
                    hours: _hours,
                    minutes: _minutes,
                }
            },
            uploadCore: function(fileAccept){
                let $talk = this.talk,
                    _accessToken = $talk.accessToken,
                    _url = this.$siteConfig.talkDomainUrl + '/upload/mediaupload',
                    _max = 20;

                let $_addFile = (opt) =>{

                        if( opt.length > _max ) {

                            this.pushPopUp({
                                type: 'alert',
                                content: {
                                    html: this.$t('talk.alert.upload.max',{ length: _max }),
                                }
                            });
                        }else {
                        
                            Array.prototype.forEach.call(opt, file => {
                                $_core(file);
                            });
                        }
                    },
                    $_core = async (file) => {
                        let _fileName = file.name.replace(/^.*[\\\/]/, ''),
                            _fileType = 3,
                            _fileExtension = _fileName.split('.').pop().toLowerCase();

                        let $formData = new FormData();

                        $formData.append('file', file); //放進上傳的檔案
                        $formData.append('accessToken', _accessToken);

                        if(_fileExtension) {
                            $formData.append('fileextension', _fileExtension);

                            switch(_fileExtension){

                                case 'mp3':
                                    _fileType = 4;
                                    break

                                case 'mp4':
                                    _fileType = 5;
                                    break

                                default:

                                    if( ['jpg', 'jpeg', 'gif', 'bmp', 'png'].includes(_fileExtension) ){
                                        _fileType = 2;
                                    }

                                    break
                            }
                                        
                            try {
                                let $response = await this.$http({
                                        method: 'post',
                                        url: _url,
                                        headers: {
                                            fileExtension: _fileExtension,
                                            uploadtocloudflag: false,
                                            uploadoriginalimage: false,
                                            uploadtogalleryflag: false,
                                        },
                                        timeout: 120000,
                                        cache: false,
                                        processData: false,
                                        contentType: false,
                                        data: $formData,
                                    }),
                                    $file = $response.data;

                                if( !!$file.uuid ) {

                                    this.talkCommand({
                                        command: 'sendMessage',
                                        cid: this.talk.cid,
                                        type: _fileType,
                                        message: _fileName,
                                        extra: Math.floor($file.timestamp / 1000 / 100000), // path
                                        extra2: $file.uuid, // filename
                                        extra3: $file.imageWidth ? $file.imageWidth : ($file.size ? $file.size : 0),
                                        extra4: $file.imageHeight ? $file.imageHeight : 0,
                                        uuid: this.$okaTool.getUUID()
                                    });
                                }

                            }catch(error) {
                            
                                this.commit('catchError', {
                                    error: error,
                                    callback: () => {
                                        $_core(file);
                                    }
                                });
                            }
                        }
                    }

                this.pushPopUp({
                    type: 'upload',
                    content: {
                        html: this.$t('talk.alert.upload.max',{ length: _max }),
                        multiple: true,
                        accept: fileAccept,
                        action: $_addFile,
                    }
                });
            },
            sendFiles: function(){
                this.uploadCore('.zip,.mp4,.mp3,.doc,.docx,.docm,.xls,.xlsx,.xlsm,.ppt,.pptx,.pptm,.pdf,.txt,.jpg,.jpeg,.png,.gif,.bmp,.csv');
            },
            sendImages: function(){
                this.uploadCore('.jpg,.jpeg,.png,.gif,.bmp');
            },
            toggleStickerPanel: function(){
                this.$set(this, 'stickerPanel', !this.stickerPanel);
            },
            closePanel: function(){
                this.$set(this, 'stickerPanel', false);
            },
            sendSticker: function(sticker){

                this.talkSend({
                    channel: this.useChannel.cid,
                    type: 6,
                    message: sticker.filename,
                });

                this.closePanel();
            },
            sendByEnter: function(e){

                if( e.ctrlKey || e.shiftKey ) {
                    e.preventDefault();

                    this.send(e.target);
                }
            },
            sendByBtn: function(){
                this.send(this.$refs.input);
            },
            send: function(evt){
                let _text = evt.value;

                if( _text ) {
                    this.talkSend({
                        channel: this.talk.cid,
                        message: _text,
                    });

                    evt.removeAttribute('style');
                    evt.value = '';
                }
            },
            scroll: function(token){
                let $scroll = token.split('_'),
                    _away = $scroll[0]

                let $content = this.$refs.content,
                    $_core = (num) => {
                        $content.scrollTop = num;
                    }

                if( _away === 'bottom' ) {
                    $_core($content.scrollHeight);
                }else if( _away === 'top' ) {
                    $_core(0);
                // }else if( _away === 'find' ) { //找某個 UUID
                //     let _uuid = $scroll[1],
                //         $talkList = this.talkList,
                //         $target = $talkList.find(talk => talk.sn === _uuid),
                //         _index = $talkList.indexOf($target),
                //         $nodes = $content.querySelectorAll('ul.talk > li'),
                //         $node = $nodes[_index],
                //         _height = $node.offsetTop;

                //     $_core(_height);

                }else if( _away === 'prev' ) { //回上次
                    let _number = $content.scrollHeight - this.scrollPrev;

                    $_core(parseInt(_number, 10));

                }else if( _away === 'to' ) { //設定一個高度
                    let _number = $scroll[1];

                    $_core(parseInt(_number, 10));
                }
            },
            initScroll: function(){
                let $content = this.$refs.content,
                    $_core = () => {

                        if( $content.scrollTop === 0 ) {
                            this.scroll('to_10');

                            this.$set(this, 'scrollPrev', $content.scrollHeight);

                            this.talkCommand({
                                command: 'getMessage',
                                cid: this.talk.cid,
                                timestamp: this.talkMessage[0].timestamp,
                                direction: 'up',
                                updateTimeFlag: true
                            });
                        }
                    }

                if( $content ) {
                    $content.addEventListener('scroll', $_core, true);
                }
            },
        },
    }
</script>

<style scoped lang="scss">

    .md.talk-box {
        $btn_z: 26px;
        $pic_z: 36px;
        $ft_z: 32px;
        $label_z: 50px;

        %user-pic {
            width: $pic_z;
            height: $pic_z;
            border-radius: $pic_z;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
        }

        z-index: 4;
        position: fixed;
        display: flex;
        flex-direction: column;
        right: 60px;
        height: calc(100vh - 200px);
        max-height: 600px;
        bottom: $interval-m;
        background-color: $white;
        border-radius: $border-radius;
        width: 360px;
        max-width: calc(100vw - 80px);
        box-shadow: $box-shadow;
        transition: right $transition;

        &.is-extend {
            right: 430px;

            @include media('phone') {
                right: 330px;
            }
        }

        @include media('phone') {
            width: 260px;
            max-height: none;
            height: calc(100vh - 150px);
        }

        .heading {
            flex-shrink: 0;
            display: flex;
            background-color: $major-color;
            border-radius: $border-radius $border-radius 0 0;
            padding: $interval-s;

            .caption {
                display: flex;
                flex: 1;
                width: 0;

                .image {
                    @extend %user-pic;
                }

                .name {
                    padding: 0 $interval-s;
                    flex-grow: 1;
                    font-size: $font-size-l;
                    line-height: $pic_z;
                    color: $white;

                    .box {
                        @extend %ellipsis;
                    }
                }
            }

            /*ul*/.func {
                @extend %reset;
                display: flex;
                padding-left: $interval-m;
                align-items: center;

                li {

                    + li {
                        padding-left: $interval-s;
                    }

                    &.minisize {
                        
                        a {
                            
                            &::before {
                                content: '\e15b';
                            }
                        }
                    }

                    &.remove {
                        
                        a {
                            
                            &::before {
                                content: '\e14c';
                            }
                        }
                    }
                }

                a {
                    transition: $transition;
                    display: block;
                    height: $ft_z;
                    width: $ft_z;
                    text-align: center;
                    cursor: pointer;
                    border-radius: $border-radius;
                    background-color: $minor-color;
                    color: $deep;

                    &:hover {
                        opacity: $opacity-m
                    }

                    &::before {
                        display: block;
                        @extend %font-pseudo;
                        line-height: $ft_z;
                    }
                }
            }
        }

        .content {
            flex-grow: 1;
            flex-shrink: 1;
            position: relative;

            .box {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                overflow-y: auto;
                overflow-x: hidden;
                overscroll-behavior: contain;
            }

            ul.talk {
                $arrow_z: 4px;

                @extend %reset;
                padding: $interval-m;
                
                li {

                    + li {
                        margin-top: $interval-m;
                        margin-left: 0;
                    }

                    &.is-system {
                        
                    }

                    &.is-self {
                        margin-left: $label_z;
                        margin-right: 0;
                        display: flex;
                        flex-direction: row-reverse;

                        .user-name {
                            display: none;
                        }

                        .user-image {
                            display: none;
                        }

                        .text-content {
                            background-color: $minor-color;
                            border-top-right-radius: 0;

                            &:before {
                                left: 100%;
                                border-left-width: $arrow_z;
                                border-left-color: $minor-color;
                                border-top-color: $minor-color;
                            }
                        }

                        .label {
                            right: calc(100% + #{$interval-xs});
                            text-align: right;
                        }
                    }

                    &.is-other {
                        margin-right: $label_z;

                        .text-content {
                            border-top-left-radius: 0;

                            &:before {
                                right: 100%;
                                border-right-width: $arrow_z;
                                border-right-color: $light;
                                border-top-color: $light;
                            }
                        }

                        .label {
                            left: calc(100% + #{$interval-xs});
                        }
                    }
                }

                .date-content {
                    width: 50px;
                    margin: $interval-l auto;
                    padding: 0 $interval-m;
                    text-align: center;
                    font-size: $font-size-xs;
                    background-color: $gray;
                    color: $white;
                    border-radius: $border-radius;
                }

                .figure-content {
                    display: flex;
                }

                .user-image {
                    padding-right: $interval-m;

                    .image {
                        @extend %user-pic;
                    }
                }

                .message-content {
                    
                }

                .user-name {
                    font-size: $font-size-xs;
                }

                .text-content {
                    position: relative;
                    padding: $interval-s $interval-m;
                    background-color: $light;
                    text-align: left;
                    // min-width: 30px;
                    // min-height: 22px;
                    border-radius: $border-radius;

                    &:before {
                        content: $content;
                        position: absolute;
                        width: 0;
                        height: 0;
                        top: 0;
                        border: $arrow_z solid transparent;
                        border-top-width: $arrow_z;
                    }

                    .text {

                        .url {
                            text-decoration: underline;
                            cursor: pointer;

                            &:hover {
                                text-decoration: none;
                            }

                            &::before {
                                margin-right: $interval-xs;
                                @extend %font-pseudo;
                            }

                            &.is-link {
                                word-break: break-all;

                                &::before {
                                    content: '\e157';
                                }
                            }

                            &.is-file {

                                &::before {
                                    content: '\e226';
                                }
                            }
                        }
                    }

                    .image {
                        position: relative;
                        background-repeat: no-repeat;
                        background-size: contain;
                        background-position: center;

                        &.is-sticker {
                            height: 120px;
                            width: 120px;
                        }

                        &.is-pic {
                            height: 160px;
                            width: 160px;
                            cursor: pointer;
                        }

                        &:hover {

                            &::v-deep {

                                .cp.label {
                                    display: block;
                                }
                            }
                        }

                        &::v-deep {

                            .cp.label {
                                display: none;
                                position: absolute;
                                left: 0;
                                top: $interval-s;
                                bottom: auto;
                                cursor: pointer;

                                &:hover {
                                    opacity: $opacity-h
                                }
                            }
                        }
                    }

                    .product {
                        width: 180px;
                        text-align-last: left;

                        a {
                            display: flex;
                            color: inherit;
                        }

                        .image {
                            width: 60px;
                            height: 60px;
                            background-size: contain;
                            background-position: center;
                            background-color: $white;
                            background-repeat: no-repeat;

                            img {
                                display: none;
                            }
                        }

                        .p {
                            flex: 1;
                            padding-left: $interval-m;

                            .caption {
                                font-weight: bold;
                            }

                            .price {
                                margin-top: $interval-xs;
                                font-size: $font-size-s;
                            }
                        }
                    }

                    .label {
                        position: absolute;
                        white-space: nowrap;
                        box-sizing: border-box;
                        font-size: 7px;
                        line-height: 1.4;
                        color: $deep-gray;
                        bottom: 0;
                    }
                }
            }

            .panel {
                /*ul*/.func {
                    @extend %reset;
                    position: absolute;
                    left: 50%;
                    margin-left: -0.5 * $btn_z;
                    top: 0;
                    margin-top: -0.5 * $btn_z;
                    right: 0;
                    z-index: 2;

                    li {

                        + li {
                            padding-left: $interval-xs;
                        }

                        &.remove {
                            
                            a {
                                
                                &::before {
                                    content: '\e14c';
                                }
                            }
                        }
                    }

                    a {
                        transition: $transition;
                        display: block;
                        height: $btn_z;
                        width: $btn_z;
                        text-align: center;
                        background-color: $black;
                        color: $white;
                        cursor: pointer;
                        border-radius: 50%;

                        &:hover {
                            opacity: $opacity-m
                        }

                        &::before {
                            display: block;
                            @extend %font-pseudo;
                            line-height: $btn_z;
                        }
                    }
                }
            }

            ul.sticker {
                @extend %reset;
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background-color: rgba-set($white, $opacity-m);
                backdrop-filter: saturate(120%) blur(4px);
                z-index: 1;
                overflow-y: auto;
                overflow-x: hidden;
                overscroll-behavior: contain;
                display: flow-root;
                padding-top: $interval-m;

                li {
                    float: left;
                    width: 50%;
                    box-sizing: border-box;
                    padding: $interval-m;

                    a {
                        display: block;
                        height: 110px;
                        background-repeat: no-repeat;
                        background-position: center;
                        background-size: contain;
                        transition: $transition;
                        transform-origin: center;
                        cursor: pointer;

                        &:hover {
                            transform: scale(1.2)
                        }
                    }

                    img {
                        display: none;
                    }
                }
            }
        }

        .footer {
            $lh: $ft_z - $interval-xs * 2 - 2px;

            flex-shrink: 0;
            padding: $interval-s;
            border-top: $border;
            background-color: $light;
            display: flex;
            border-radius: 0 0 $border-radius $border-radius;

            .talk-input {
                flex: 1;
                width: 0;
                overflow: auto;

                .box {
                    line-height: $lh;
                    height: 38px;
                    margin: 0;
                    width: 100%;
                    resize: none;
                    outline: none;
                    margin: 0;
                    border-radius: $border-radius;

                    &::-webkit-scrollbar {
                        display: none;
                    }
                }
            }

            /*ul*/.func {
                @extend %reset;
                display: flex;
                padding-left: $interval-s;

                li {
                    display: flex;

                    + li {
                        margin-left: $interval-xs;
                    }

                    &.send {
                        
                        a {
                            background-color: $minor-color;

                            &:hover {
                                background-color: $major-color;

                                &::before {
                                    color: $white;
                                }
                            }

                            &::before {
                                content: '\e163';
                            }
                        }
                    }
                    
                    &.file {
                        
                        a {

                            &::before {
                                content: '\e226';
                            }
                        }
                    }
                    
                    &.image {
                        
                        a {

                            &::before {
                                content: '\e413';
                            }
                        }
                    }
                    
                    &.sticker {

                        &.is-active {

                            a {
                                background-color: $major-color;

                                &::before {
                                    color: $white;
                                }
                            }
                        }
                        
                        a {

                            &::before {
                                content: '\e813';
                            }
                        }
                    }
                }

                a {
                    transition: $transition;
                    display: flex;
                    width: $ft_z;
                    cursor: pointer;
                    align-items: center;
                    justify-content: center;
                    border-radius: $border-radius;

                    &::before {
                        @extend %font-pseudo;
                    }

                    &:hover  {
                        background-color: $minor-color;
                    }
                }
            }
        }
    }
</style>
